var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.5 41.5",
    style: {
      enableBackground: "new 0 0 41.5 41.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C4C4C4;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20.75,
    cy: 20.75,
    r: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.75,11.33c-4.96,0-8.99,4.02-8.99,8.99c0,1.95,0.62,3.76,1.68,5.23c0.03,0.06,0.07,0.12,0.11,0.17 l6.37,8.14c0,0,0.01,0.01,0.01,0.01c0.04,0.05,0.08,0.09,0.13,0.13c0.01,0.01,0.02,0.02,0.04,0.03c0,0,0,0,0,0 c0.06,0.04,0.12,0.08,0.18,0.11c0.02,0.01,0.04,0.02,0.05,0.02c0.05,0.02,0.1,0.04,0.15,0.05c0.02,0,0.04,0.01,0.06,0.01 c0.07,0.01,0.14,0.02,0.21,0.02c0,0,0,0,0,0c0,0,0,0,0,0c0.07,0,0.14-0.01,0.21-0.02c0.02,0,0.04-0.01,0.06-0.01 c0.05-0.01,0.1-0.03,0.15-0.05c0.02-0.01,0.04-0.01,0.05-0.02c0.06-0.03,0.12-0.07,0.18-0.11c0,0,0,0,0,0 c0.01-0.01,0.02-0.02,0.04-0.03c0.05-0.04,0.09-0.08,0.13-0.13c0,0,0.01-0.01,0.01-0.01l6.37-8.14c0.04-0.06,0.08-0.11,0.11-0.17 c1.06-1.47,1.68-3.28,1.68-5.23C29.74,15.35,25.71,11.33,20.75,11.33z M20.75,23.55c-2.11,0-3.82-1.71-3.82-3.82 c0-2.11,1.71-3.82,3.82-3.82c2.11,0,3.82,1.71,3.82,3.82C24.57,21.84,22.86,23.55,20.75,23.55z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon_9.7d3992603a03672f52ea4927426d0205.svg";
export { ForwardRef as ReactComponent };